import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { StatsState } from './types';

export const getters: GetterTree<StatsState, RootState> = {
  //
};
